import { render, staticRenderFns } from "./DetailRichText.vue?vue&type=template&id=5e450fff&scoped=true&lang=pug&"
import script from "./DetailRichText.vue?vue&type=script&lang=js&"
export * from "./DetailRichText.vue?vue&type=script&lang=js&"
import style0 from "./DetailRichText.vue?vue&type=style&index=0&id=5e450fff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e450fff",
  null
  
)

export default component.exports